import { Component, OnInit, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subject, Observable } from 'rxjs';
import * as _ from 'underscore';
import { RootStoreState } from 'src/app/root-store';
import { takeUntil } from 'rxjs/operators';
import { ColumnConfigItem } from 'src/app/models/ColumnConfigItem';

import { getCurrentUser } from 'src/app/root-store/main-app-store/selectors/auth.selector';
import { Product } from 'src/app/models/Product.model';
import { getPagedProductList, getPagedProductListError, getPagedProductListLoading } from 'src/app/root-store/kwikspace-app-store/selectors/product.selector';
import { ClearProductList, GetPagedProductList } from 'src/app/root-store/kwikspace-app-store/actions/product.action';
import { PaginationService } from 'src/app/services/pagination.service';

@Component({
  selector: 'kwikspace-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();

  productsLoading$: Observable<any> = this.store.select(getPagedProductListLoading);
  productsError$: Observable<any> = this.store.select(getPagedProductListError);

  products: Product[];
  pageCount = 1;
  pageLinks;
  itemCount = 0;
  currentPage = 1;
  pageToLoad;

  iconClass: string;
  columnConfig: ColumnConfigItem[];

  filterBy: any;
  sortBy: any;
  searchTerm: any;

  hasProducts: boolean = false;

  constructor(
    private store: Store<RootStoreState.RootState>,
    private paginationService: PaginationService
  ) { }

  ngOnInit() {
    this.iconClass = 'fa fa-user text-white';

    this.columnConfig = [
      {
        oldName: 'id',
        isVisible: false
      },
      {
        oldName: 'name',
        isVisible: false
      },
      {
        oldName: 'description',
        isVisible: false
      },
      {
        oldName: 'unitOfMeasure',
        isVisible: false
      }
    ];

    this.store
      .select(getCurrentUser)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.getProducts();
        }
      });

    this.store
      .select(getPagedProductList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((products: any) => {
        if (products && products.results) {
          this.itemCount = products.count;
          this.pageLinks = products.links;
          this.pageCount = this.itemCount < 10 ? 1 : Math.ceil(this.itemCount / 10);

          this.searchTerm = '';
          this.filterBy = '';
          this.sortBy = '';

          this.buildProductsTable(products.results);
        }
      });
  }

  buildProductsTable(products) {
    if (products.length > 0) {
      products.forEach(rental => {
        Object.keys(rental).forEach(key => {
          let obj = rental[key];
          if (key == 'category') {
            rental[key] = obj.name;
          }
          if (key == 'subCategory') {
            rental[key] = obj.name;
          }
        });
      });
    }

    this.products = products;
    this.hasProducts = this.products ? true : false;
  }

  getProducts() {
    this._reloadList();
  }

  viewItem(productDetails: any) {
    // get by id
    // # routing
  }

  retry() {
    this.getProducts();
  }

  sort(sortableOptions: any) {
    this.currentPage = 1;

    this.sortBy = sortableOptions;
    this._reloadList();
  }

  search(searchTerm: string) {
    this.currentPage = 1;

    this.searchTerm = searchTerm;
    this._reloadList();
  }

  paginate(page: string) {
    let pageProps: any = this.paginationService.getPageProps(page, this.pageCount, this.pageLinks);

    this.currentPage = pageProps.current;
    this.pageToLoad = pageProps.pageToLoad;

    this._reloadList();
  }

  private _reloadList() {
    this.store.dispatch(new ClearProductList());
    this._loadList();
  }

  _loadList() {
    this.store.dispatch(
      new GetPagedProductList({
        search: this.searchTerm,
        sort: this.sortBy,
        page: this.pageToLoad,
      })
    );
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
